<template>
    <div>
      <v-row>
        <v-col cols="12" sm="12">
          <h2 class="blue-grey--text text--darken-1"><b>Lease period:</b> 
              <localized-date :date="registration.startDate" />
              - <localized-date :date="registration.endDate" />
          </h2>                        
        </v-col>
        <v-col cols="12" sm="6">
          <h2 class="blue-grey--text text--darken-1">Leased Dog:</h2>
          <v-row class="mt-5">
            <v-col cols="2">
              <v-img :src="defaultImage" class="profile-picture" min-width="40px" max-width="40px" contain />
            </v-col>
            <v-col cols="10">
              <h3><b>{{registration.leasedDog.name}}</b></h3>
              <span>{{registration.leasedDog.dogId}} • {{registration.leasedDog.body}} • {{registration.leasedDog.dnaStatus}}</span>
            </v-col>
          </v-row>      
          <CoownersList :owners="registration.leasedDog.owners" :ownershipType="dogOwnershipType" />
        </v-col>
        <v-divider vertical light class="d-none d-sm-flex"></v-divider>
        <v-col cols="12" sm="6">
          <h2 class="blue-grey--text text--darken-1">Lessees:</h2>
          <CoownersList :owners="registration.lessees" :ownershipType="leaseOwnershipType" :hideHeader="true"/>
        </v-col>
      </v-row>
    </div>               
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

const defaultImage = require('@/assets/photouploadblue.png');

export default Vue.extend({
  name: "LeaseRequest",
  components: {
    CoownersList,
  },
  props: {
    registration: { type: Object },
  },
  data() {
    return {
      defaultImage,
    };
  },
  computed: {
    dogOwnershipType: function() {
      return OwnershipType.Dog;
    },
    leaseOwnershipType: function() {
      return OwnershipType.Lease;
    },
  },
});
</script>
